
























import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
@Component({})
export default class Box extends Vue {
  @Prop({
    type: String,
    default() {
      return '';
    }
  })
  title!: string;
  @Prop({
    type: Number,
    default() {
      return 0;
    }
  })
  count!: number;
  @Prop({
    type: Boolean,
    default() {
      return false;
    }
  })
  insufficient!: boolean;
}
